import { TextField } from '@mui/material'
import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import { useGridApiContext } from '@mui/x-data-grid-pro'
import React from 'react'

import { editorSx } from './editorStyles'

export const TextEditor: React.FC<GridRenderEditCellParams> = (params) => {
	const apiRef = useGridApiContext()
	const value = (params.value ?? '') as string
	return (
		<TextField
			value={value}
			onChange={(e) => apiRef.current.setEditCellValue({ id: params.id, field: params.field, value: e.target.value })}
			size="small"
			fullWidth
			autoFocus
			placeholder={params.colDef.headerName ?? ''}
			sx={editorSx}
		/>
	)
}
